<template>
  <div v-if="address">
    <div v-if="hasMissingTaxZone(address.tax_setting)">
      <i class="fa fa-exclamation-circle mr-1 sera-color-text-error"></i>
      <span v-if="!omitLabel" class="text-title">Taxes: </span>
      <span class="sera-color-text-error">Missing Tax Zone</span>
    </div>
    <div v-else>
      <span v-if="!omitLabel" class="text-title">Taxes: </span>
      <span>{{ taxabilityOneLineDisplay(address.tax_setting) }}</span>
      <sera-button
        v-if="showEditTaxSettings"
        class="ml-2"
        link
        label="Edit"
        icon="badge-percent"
        @click="emit('edit-tax-settings')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import SeraButton from "@/components/Button.vue";
import { Address } from "@/typings/address";
import {
  hasMissingTaxZone,
  taxabilityOneLineDisplay
} from "@/typings/taxability";

defineProps({
  omitLabel: {
    type: Boolean,
    default: false
  },
  showEditTaxSettings: {
    type: Boolean,
    default: false
  },
  address: {
    type: Object as () => Address,
    default: null
  }
});
const emit = defineEmits(["edit-tax-settings"]);
</script>
